import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
}));

export default useStyles;
